import React from "react";
import Table from "./Table";

const ReportDetails = () => {
  return (
    <section>
      <Table />
    </section>
  );
};

export default ReportDetails;
